import { UntypedFormGroup } from '@angular/forms';

export class ApplicantView {
  name: string;
  form: UntypedFormGroup;
  type: 'New' | 'Person' | 'Shareholder' | 'Company';
  customerId: string;
  isProcessing: boolean;
  isProcessed: boolean;

  isValid(): boolean {
    return false;
  }
}
